import { Product } from "../../../../interfaces/domain/menu";
import { PricePlate } from "../../../atoms";
import { useOrdersStore } from "../../../../store";
import styles from "./PlateInfo.module.scss";

interface PlateInfoProps {
  plate: Product;
  section?: string;
  onOpenModal: () => void;
}

export const PlateInfo = ({ plate, section, onOpenModal }: PlateInfoProps) => {
  const isMainPlate = section === "mainPlate";



  return (
    <div
      className={isMainPlate ? styles.containerMain : styles.containerDefault}
      onClick={onOpenModal}
    >
      <div className={isMainPlate ? styles.innerMain : styles.inner}>
        <h3 className={styles.title}>{plate.title}</h3>

        {!isMainPlate && (
          <p className={styles.description}>
            {plate.description || plate.title}
          </p>
        )}

        <PricePlate plate={plate} />
      </div>
    </div>
  );
};
